export function joinStringsWithLimit(
    strings: string[],
    maxTotalLength: number,
    maxWordsPerString: number
): string {
    // Сначала проверяем, влезает ли полная строка без сокращений
    const fullUncutString = strings.join(', ');
    if (fullUncutString.length <= maxTotalLength) {
        return fullUncutString; // Если влезает — возвращаем как есть
    }

    // Если не влезает — начинаем сокращать
    let result = '';
    let currentLength = 0;

    for (let i = 0; i < strings.length; i++) {
        const originalString = strings[i];
        const words = originalString.split(/\s+/).filter(word => word.length > 0);
        let processedString: string;

        if (words.length > maxWordsPerString) {
            processedString = words.slice(0, maxWordsPerString).join(' ') + '...';
        } else {
            processedString = originalString;
        }

        const separator = i > 0 ? ', ' : '';
        const newPart = separator + processedString;

        if (currentLength + newPart.length > maxTotalLength) {
            const remainingSpace = maxTotalLength - currentLength;
            if (remainingSpace >= 3) {
                result += '...';
            }
            break;
        }

        result += newPart;
        currentLength += newPart.length;
    }

    return result;
}
export function getClientUID() {
    let clientUID = window.localStorage.getItem("clientUID")
    if (!clientUID) {
        clientUID = crypto.randomUUID()
        window.localStorage.setItem("clientUID", clientUID)
    }
    return clientUID
}
